import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private readonly snackBar: MatSnackBar) { }

  openSnackbar(message: string, messageType: string): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      verticalPosition: 'top',
      data: message,
      panelClass: [messageType]         
    });
  }
}